import React, { useState } from 'react';
import css from './DownApp.less';

const wxappIcon = require('~/static/qrcode/wxapp.png');

const DownApp = () => {
  const [qrcode] = useState(wxappIcon);

  return (
    <div className={css.content}>
      <p className={css.scanMsg}>立即扫码</p>
      <p className={css.mark}>小程序查看更多内容</p>
      <img className={css.qrcode} src={qrcode} alt="qrcode" />
    </div>
  );
};

export default DownApp;
